var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSorting = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42334 7.36707L6.28885 10.3023C6.15914 10.4806 5.91006 10.5196 5.73253 10.3893C5.70199 10.3668 5.67479 10.3402 5.65174 10.31L3.40651 7.37484C3.27253 7.19968 3.30524 6.94855 3.47957 6.81393C3.54914 6.76021 3.63443 6.73109 3.72217 6.73109H8.10188C8.32176 6.73109 8.5 6.91017 8.5 7.13109C8.5 7.21592 8.47315 7.29857 8.42334 7.36707Z",
    fill: "#2C4652",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37665 4.09924L5.51114 1.16405C5.64085 0.985672 5.88992 0.946724 6.06746 1.07705C6.098 1.09947 6.1252 1.12615 6.14825 1.15628L8.39347 4.09147C8.52746 4.26663 8.49475 4.51776 8.32042 4.65237C8.25084 4.7061 8.16556 4.73522 8.07782 4.73522H3.6981C3.47823 4.73522 3.29999 4.55614 3.29999 4.33522C3.29999 4.25038 3.32683 4.16774 3.37665 4.09924Z",
    fill: "#2C4652",
    fillOpacity: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSorting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sorting.8148761f.svg";
export { ForwardRef as ReactComponent };